const statsData = [
  { title: "Years of Experience", number: "3+" },
  { title: "Stores Managed", number: "50+" },
  { title: "Profit Generated", number: "$700K+" },
  { title: "Sales Generated", number: "$4M+" },
];

export default statsData;
